import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import AutoComplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';

function CreateTransferOrdersForm(props) {

    return (
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{display: 'flex', flexDirection: 'column'}}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{display: 'flex', flexDirection: props.isMobile ? 'column' : 'row', mb: '10px'}}>
                <label>Select To/ From Warehouses</label>
            </Box>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{display: 'flex', flexDirection: props.isMobile ? 'column' : 'row', mb: '10px'}}>
                <FormControl sx = {{ width: '20%', mr: '0.6%' }}>
                    <AutoComplete
                        value = {props.warehouse_options.find(option => option.value === props.warehouses) || null}
                        onChange = {(event, newValue) => {
                            props.setWarehouses(newValue ? newValue.value : null);
                        }}
                        id = "status"
                        options = {props.warehouse_options}
                        getOptionLabel = {(option) => {
                            return `${option.name}`;
                        }}
                        renderOption = {(props, option) => {
                            return (
                                <li {...props}>
                                    {`${option.name}`}
                                </li>
                            );
                        }}
                        renderInput = {(params) => (
                            <TextField {...params} label = "Warehouses *" />
                        )}
                    />
                </FormControl>
                { props.warehouses ? 
                    <Button 
                        variant = 'contained' 
                        onClick = {props.createTransferOrder} 
                        sx = {{
                            background: 'linear-gradient(to right, #FFDBE9, #182D09)'
                        }}
                        disabled = {props.loading}
                    >
                        Create Transfer Orders
                    </Button>
                : null }
            </Box>
        </Box>
    );
};

export default CreateTransferOrdersForm;